import React from "react";
import { ChevronRight } from "lucide-react";
import { ConversationTicket, IssueStatus } from "../../types/feedback";

const STATUS_META: Record<IssueStatus, { label: string; color: string }> = {
  open: { label: "Open", color: "#F59E0B" },
  in_progress: { label: "In progress", color: "#3B82F6" },
  resolved: { label: "Resolved", color: "#10B981" },
};

interface Props {
  ticket: ConversationTicket;
  // Open the ticket as its own full thread view.
  onOpen: (ticketId: string) => void;
}

// TicketCard is a tappable summary embedded in the chat timeline. Tapping it
// opens the ticket as its own thread (with its own single composer) rather than
// expanding inline.
const TicketCard: React.FC<Props> = ({ ticket, onOpen }) => {
  const meta = STATUS_META[ticket.status] ?? STATUS_META.open;
  return (
    <button
      onClick={() => onOpen(ticket._id)}
      className="mx-auto w-[90%] my-4 flex items-center gap-3 rounded-xl border border-purple-200 bg-purple-50 px-4 py-3 text-left hover:bg-purple-100 transition-colors"
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="text-xs font-bold text-purple-700">🎫 Ticket</span>
          <span
            className="text-[11px] px-2 py-0.5 rounded-full"
            style={{ color: meta.color, backgroundColor: `${meta.color}1A` }}
          >
            {meta.label}
          </span>
        </div>
        <p className="text-sm font-semibold text-purple-900 truncate">
          {ticket.subject}
        </p>
        <p className="text-[11px] text-purple-500 mt-0.5">
          {ticket.messageCount} message{ticket.messageCount === 1 ? "" : "s"} ·
          tap to open
        </p>
      </div>
      <ChevronRight size={18} className="text-purple-400 shrink-0" />
    </button>
  );
};

export default TicketCard;
